import { Get } from "../utils/api";
import { useQuery } from "react-query";
import { ImageSet } from "../../types/api/ImageSet";
import { useAuth0 } from "@auth0/auth0-react";

export default (organizationId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery(
    `image_set_${organizationId}`,
    async () => {
      return await Get<ImageSet>(
        `/api/organization/${organizationId}/image_set`,
        await getAccessTokenSilently()
      );
    },
    { refetchInterval: false }
  );
};
